/* ============================================================
   HyperFocus Athletics — STATEMENT Wizard
   Flat-priced single-variant wizard for Statement Graphics.
   Works for any athlete level. Photo upload is OPTIONAL.
   Statement text is always required (centerpiece of the graphic).
   ============================================================ */
(function () {
  'use strict';

  const TOTAL_STEPS = 14;
  const REVIEW_STEP = 14;
  const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  const STORAGE_KEY = 'hf-wiz-statement-progress-v3';
  const STORAGE_TTL_MS = 7 * 24 * 60 * 60 * 1000;

  function initWizard(root) {
    if (!root || root.dataset.hfWizInitialized === 'true') return;
    if (root.dataset.wizardType !== 'statement') return;
    root.dataset.hfWizInitialized = 'true';

    // ─── Config ────────────────────────────────────────────────
    const cfg = {
      baseVariantId: root.dataset.baseVariantId,
      basePrice: parseFloat(root.dataset.basePrice) || 0,
      jerseyVariantId: root.dataset.jerseyVariantId,
      jerseyPrice: parseFloat(root.dataset.jerseyPrice) || 0,
      rushVariantId: root.dataset.rushVariantId,
      rushPrice: parseFloat(root.dataset.rushPrice) || 0,
      cloudinaryCloud: root.dataset.cloudinaryCloud,
      cloudinaryPreset: root.dataset.cloudinaryPreset
    };

    // ─── State ─────────────────────────────────────────────────
    const state = {
      step: 1,
      answers: {
        firstName: '', lastName: '', email: '',
        sport: '', position: '', jerseyNumber: '',
        currentLevel: '', statementType: '',
        currentSchool: '', currentSchoolCity: '', currentSchoolState: '',
        destinationSchool: '',
        statementText: '',
        graphicStyle: '',
        athletePhotoUrl: '', athletePhotoName: '',
        signaturePhotoUrl: '', signaturePhotoName: '',
        jerseySwap: '', rushTurnaround: ''
      }
    };

    // ─── Element refs ──────────────────────────────────────────
    const stepEls = Array.from(root.querySelectorAll('[data-hf-wiz-step]'));
    const progressFill = root.querySelector('[data-hf-wiz-progress-fill]');
    const stepCurrentEl = root.querySelector('[data-hf-wiz-step-current]');
    const stepTotalEl = root.querySelector('[data-hf-wiz-step-total]');
    const resetBtn = root.querySelector('[data-hf-wiz-reset]');
    const prevBtn = root.querySelector('[data-hf-wiz-prev]');
    const nextBtn = root.querySelector('[data-hf-wiz-next]');
    const navEl = root.querySelector('[data-hf-wiz-nav]');
    const submitBtn = root.querySelector('[data-hf-wiz-submit]');
    const submitErrorEl = root.querySelector('[data-hf-wiz-submit-error]');
    const totalEl = root.querySelector('[data-hf-wiz-total]');
    const runningTotalEl = root.querySelector('[data-hf-wiz-running-total]');
    const runningTotalWrap = root.querySelector('[data-hf-wiz-running-total-wrap]');
    let lastTotal = null;

    if (stepTotalEl) stepTotalEl.textContent = TOTAL_STEPS;

    // ─── localStorage ──────────────────────────────────────────
    function saveProgress() {
      try {
        localStorage.setItem(STORAGE_KEY, JSON.stringify({ step: state.step, answers: state.answers, savedAt: Date.now() }));
        if (resetBtn) resetBtn.hidden = state.step <= 1 && isAnswersEmpty();
      } catch (e) {}
    }
    function loadProgress() {
      try {
        const saved = localStorage.getItem(STORAGE_KEY);
        if (!saved) return null;
        const parsed = JSON.parse(saved);
        if (!parsed || !parsed.answers) return null;
        if (parsed.savedAt && Date.now() - parsed.savedAt > STORAGE_TTL_MS) { clearProgress(); return null; }
        return parsed;
      } catch (e) { return null; }
    }
    function clearProgress() { try { localStorage.removeItem(STORAGE_KEY); } catch (e) {} }
    function isAnswersEmpty() { return Object.values(state.answers).every(v => !v); }

    // ─── Restore UI ────────────────────────────────────────────
    function restoreUI() {
      Object.keys(state.answers).forEach(key => {
        const input = root.querySelector(`[data-hf-wiz-input="${key}"]`);
        if (input && state.answers[key]) input.value = state.answers[key];
      });
      ['sport','currentLevel','statementType','graphicStyle','jerseySwap','rushTurnaround'].forEach(key => {
        const value = state.answers[key];
        if (!value) return;
        root.querySelectorAll(`[data-hf-wiz-select="${key}"]`).forEach(btn => {
          if (btn.dataset.value === value) btn.classList.add('is-selected');
        });
      });
      if (charCountEl && state.answers.statementText) {
        charCountEl.textContent = state.answers.statementText.length;
        if (charCountWrap) charCountWrap.classList.toggle('is-warning', state.answers.statementText.length > 1400);
      }
      const url = state.answers.athletePhotoUrl;
      if (url) {
        const uploadEl = root.querySelector(`[data-hf-wiz-upload="athletePhoto"]`);
        if (uploadEl) {
          uploadEl.classList.add('has-file');
          const img = uploadEl.querySelector('[data-hf-wiz-upload-preview]');
          const fnEl = uploadEl.querySelector('[data-hf-wiz-upload-filename]');
          const previewEl = uploadEl.querySelector('.hf-wiz__upload-preview');
          if (img) img.src = url;
          if (fnEl) fnEl.textContent = state.answers.athletePhotoName || 'Restored upload';
          if (previewEl) previewEl.hidden = false;
        }
      }
    }

    // ─── Step navigation ───────────────────────────────────────
    function goToStep(n) {
      n = Math.max(1, Math.min(TOTAL_STEPS, n));
      state.step = n;
      stepEls.forEach(el => el.classList.toggle('is-active', parseInt(el.dataset.hfWizStep, 10) === n));
      if (progressFill) progressFill.style.width = `${(n / TOTAL_STEPS) * 100}%`;
      if (stepCurrentEl) stepCurrentEl.textContent = n;
      if (prevBtn) prevBtn.disabled = n === 1;
      if (navEl) navEl.classList.toggle('is-hidden', n === REVIEW_STEP);
      if (nextBtn) {
        const labelSpan = nextBtn.querySelector('span:not(.hf-wiz__nav-arrow)');
        if (labelSpan) labelSpan.textContent = n === TOTAL_STEPS - 1 ? 'Review' : 'Next';
      }
      if (resetBtn) resetBtn.hidden = n <= 1 && isAnswersEmpty();
      if (n === REVIEW_STEP) renderReview();
      updateRunningTotal();
      saveProgress();
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }

    // ─── Validation ────────────────────────────────────────────
    function validateStep(n) {
      root.querySelectorAll('.hf-wiz__field.is-invalid').forEach(el => el.classList.remove('is-invalid'));
      const a = state.answers;
      switch (n) {
        case 1: {
          let ok = true;
          if (!a.firstName.trim()) { flagInvalid('firstName'); ok = false; }
          if (!a.lastName.trim()) { flagInvalid('lastName'); ok = false; }
          if (!EMAIL_RE.test(a.email.trim())) { flagInvalid('email'); ok = false; }
          return ok;
        }
        case 2: return !!a.sport;
        case 3: return true;  // Position & Number optional (some sports don't use)
        case 4: return !!a.currentLevel;
        case 5: return !!a.statementType;
        case 6: {
          let ok = true;
          if (!a.currentSchool.trim()) { flagInvalid('currentSchool'); ok = false; }
          if (!a.currentSchoolCity.trim()) { flagInvalid('currentSchoolCity'); ok = false; }
          if (!a.currentSchoolState.trim()) { flagInvalid('currentSchoolState'); ok = false; }
          return ok;
        }
        case 7: return true; // optional destinationSchool
        case 8: { const ok = !!a.statementText.trim(); if (!ok) flagInvalid('statementText'); return ok; }
        case 9: return !!a.graphicStyle;
        case 10: return true; // optional athlete photo
        case 11: return true; // Signature — optional
        case 12: return !!a.jerseySwap;         // Jersey swap
        case 13: return !!a.rushTurnaround;    // Rush turnaround
        default: return true;                   // Review (14) and any others
      }
    }
    function flagInvalid(name) {
      const i = root.querySelector(`[data-hf-wiz-input="${name}"]`);
      if (i) i.closest('.hf-wiz__field').classList.add('is-invalid');
    }

    // ─── Inputs ────────────────────────────────────────────────
    const charCountEl = root.querySelector('[data-hf-wiz-char-count]');
    const charCountWrap = charCountEl ? charCountEl.parentElement : null;

    root.querySelectorAll('[data-hf-wiz-input]').forEach(input => {
      const key = input.dataset.hfWizInput;
      const isTextarea = input.tagName === 'TEXTAREA';
      input.addEventListener('input', () => {
        state.answers[key] = input.value;
        input.closest('.hf-wiz__field').classList.remove('is-invalid');
        if (key === 'statementText' && charCountEl) {
          charCountEl.textContent = input.value.length;
          if (charCountWrap) charCountWrap.classList.toggle('is-warning', input.value.length > 1400);
        }
        saveProgress();
      });
      input.addEventListener('keydown', e => {
        if (e.key === 'Enter' && !isTextarea && state.step < REVIEW_STEP) {
          e.preventDefault();
          handleNext();
        }
      });
    });

    // ─── Card / button selections ──────────────────────────────
    root.querySelectorAll('[data-hf-wiz-select]').forEach(btn => {
      btn.addEventListener('click', e => {
        if (e.target.closest('[data-hf-wiz-video-preview]')) return;
        const key = btn.dataset.hfWizSelect;
        const value = btn.dataset.value;
        state.answers[key] = value;
        const siblings = root.querySelectorAll(`[data-hf-wiz-select="${key}"]`);
        siblings.forEach(s => s.classList.remove('is-selected'));
        btn.classList.add('is-selected');
        updateRunningTotal();
        saveProgress();
        if (state.step < REVIEW_STEP) {
          setTimeout(() => { if (validateStep(state.step)) goToStep(state.step + 1); }, 380);
        }
      });
    });

    // ─── Signature pad (draw-in-browser signature) ─────────────
    root.querySelectorAll('[data-hf-wiz-signature]').forEach((sigWrap) => {
      const canvas = sigWrap.querySelector('[data-hf-wiz-sig-canvas]');
      const clearBtn = sigWrap.querySelector('[data-hf-wiz-sig-clear]');
      const saveBtn = sigWrap.querySelector('[data-hf-wiz-sig-save]');
      const statusEl = sigWrap.querySelector('[data-hf-wiz-sig-status]');
      const errorEl = sigWrap.querySelector('[data-hf-wiz-sig-error]');
      const thicknessEl = sigWrap.querySelector('[data-hf-wiz-sig-thickness]');
      if (!canvas || typeof SignaturePad === 'undefined') return;

      const sigPad = new SignaturePad(canvas, {
        backgroundColor: '#ffffff',
        penColor: '#000000',
        minWidth: 1.5,
        maxWidth: 3.5
      });

      function resizeCanvas() {
        const w = canvas.parentElement.clientWidth;
        if (w === 0) return;
        const ratio = Math.max(window.devicePixelRatio || 1, 1);
        const data = sigPad.toData();
        canvas.width = w * ratio;
        canvas.height = 240 * ratio;
        canvas.style.width = w + 'px';
        canvas.style.height = '240px';
        canvas.getContext('2d').scale(ratio, ratio);
        sigPad.clear();
        if (data && data.length) sigPad.fromData(data);
      }
      function updateThickness(v) {
        const val = parseFloat(v);
        sigPad.minWidth = Math.max(0.5, val * 0.3);
        sigPad.maxWidth = Math.max(1, val * 0.7);
      }

      resizeCanvas();
      window.addEventListener('resize', resizeCanvas);
      if (typeof ResizeObserver !== 'undefined') {
        new ResizeObserver(() => resizeCanvas()).observe(canvas.parentElement);
      }

      if (thicknessEl) {
        updateThickness(thicknessEl.value);
        thicknessEl.addEventListener('input', (e) => updateThickness(e.target.value));
      }

      clearBtn.addEventListener('click', () => {
        sigPad.clear();
        if (errorEl) { errorEl.hidden = true; errorEl.textContent = ''; }
        if (statusEl) { statusEl.hidden = true; statusEl.textContent = ''; }
      });

      saveBtn.addEventListener('click', () => {
        if (errorEl) { errorEl.hidden = true; errorEl.textContent = ''; }
        if (sigPad.isEmpty()) {
          if (errorEl) { errorEl.textContent = 'Please draw your signature first.'; errorEl.hidden = false; }
          return;
        }
        if (!cfg.cloudinaryCloud || !cfg.cloudinaryPreset) {
          if (errorEl) { errorEl.textContent = 'Upload is not configured yet. Please contact support.'; errorEl.hidden = false; }
          return;
        }
        saveBtn.disabled = true;
        if (statusEl) { statusEl.textContent = 'Uploading signature…'; statusEl.hidden = false; }
        canvas.toBlob(async (blob) => {
          if (!blob) {
            saveBtn.disabled = false;
            if (errorEl) { errorEl.textContent = 'Could not export signature. Try again.'; errorEl.hidden = false; }
            return;
          }
          const formData = new FormData();
          formData.append('file', blob, 'signature-drawn.png');
          formData.append('upload_preset', cfg.cloudinaryPreset);
          try {
            const res = await fetch(`https://api.cloudinary.com/v1_1/${cfg.cloudinaryCloud}/image/upload`, { method: 'POST', body: formData });
            const data = await res.json();
            if (!res.ok || !data.secure_url) throw new Error('Upload failed');
            state.answers.signaturePhotoUrl = data.secure_url;
            state.answers.signaturePhotoName = 'signature-drawn.png';
            saveProgress();
            if (statusEl) { statusEl.textContent = '✓ Signature saved. You can continue.'; statusEl.hidden = false; }
          } catch (err) {
            if (errorEl) { errorEl.textContent = 'Upload failed. Please try again or use the photo upload option.'; errorEl.hidden = false; }
            if (statusEl) { statusEl.hidden = true; }
          } finally {
            saveBtn.disabled = false;
          }
        }, 'image/png');
      });
    });

    // ─── File upload (Cloudinary) ──────────────────────────────
    const cloudinaryReady = !!(cfg.cloudinaryCloud && cfg.cloudinaryPreset);
    root.querySelectorAll('[data-hf-wiz-upload]').forEach(uploadEl => {
      const key = uploadEl.dataset.hfWizUpload;
      const fileInput = uploadEl.querySelector('[data-hf-wiz-upload-input]');
      const empty = uploadEl.querySelector('.hf-wiz__upload-empty');
      const progress = uploadEl.querySelector('.hf-wiz__upload-progress');
      const progressBar = uploadEl.querySelector('[data-hf-wiz-upload-bar]');
      const progressStatus = uploadEl.querySelector('[data-hf-wiz-upload-status]');
      const preview = uploadEl.querySelector('.hf-wiz__upload-preview');
      const previewImg = uploadEl.querySelector('[data-hf-wiz-upload-preview]');
      const filenameEl = uploadEl.querySelector('[data-hf-wiz-upload-filename]');
      const removeBtn = uploadEl.querySelector('[data-hf-wiz-upload-remove]');
      const errorEl = uploadEl.querySelector('[data-hf-wiz-upload-error]');

      if (!cloudinaryReady) {
        uploadEl.classList.add('is-disabled');
        uploadEl.style.opacity = '0.5';
        uploadEl.style.pointerEvents = 'none';
        if (errorEl) {
          errorEl.textContent = 'File upload is not configured yet. Please contact support before ordering.';
          errorEl.hidden = false;
        }
      }

      uploadEl.addEventListener('click', e => {
        if (uploadEl.classList.contains('has-file')) return;
        if (e.target.closest('[data-hf-wiz-upload-remove]')) return;
        fileInput.click();
      });
      ['dragenter','dragover'].forEach(evt => uploadEl.addEventListener(evt, e => { e.preventDefault(); uploadEl.classList.add('is-dragging'); }));
      ['dragleave','drop'].forEach(evt => uploadEl.addEventListener(evt, e => { e.preventDefault(); uploadEl.classList.remove('is-dragging'); }));
      uploadEl.addEventListener('drop', e => { const f = e.dataTransfer.files && e.dataTransfer.files[0]; if (f) handleFile(f); });
      fileInput.addEventListener('change', () => { const f = fileInput.files && fileInput.files[0]; if (f) handleFile(f); });
      removeBtn.addEventListener('click', e => {
        e.stopPropagation();
        state.answers[key + 'Url'] = '';
        state.answers[key + 'Name'] = '';
        uploadEl.classList.remove('has-file');
        previewImg.src = '';
        filenameEl.textContent = '';
        fileInput.value = '';
        errorEl.hidden = true;
        preview.hidden = true;
        empty.style.display = '';
        saveProgress();
      });

      function handleFile(file) {
        errorEl.hidden = true; errorEl.textContent = '';
        if (!file.type.startsWith('image/')) { showError('Please upload an image file (JPG, PNG, HEIC).'); return; }
        if (file.size > 25 * 1024 * 1024) { showError('File is too large. Maximum size is 25MB.'); return; }
        if (!cfg.cloudinaryCloud || !cfg.cloudinaryPreset) { showError('Upload is not configured yet. Please contact support.'); return; }
        empty.style.display = 'none';
        progress.hidden = false;
        uploadEl.dataset.uploading = 'true';
        progressBar.style.width = '0%';
        progressStatus.textContent = 'Uploading…';
        const url = `https://api.cloudinary.com/v1_1/${cfg.cloudinaryCloud}/image/upload`;
        const formData = new FormData();
        formData.append('file', file);
        formData.append('upload_preset', cfg.cloudinaryPreset);
        const xhr = new XMLHttpRequest();
        xhr.open('POST', url);
        xhr.upload.addEventListener('progress', e => {
          if (e.lengthComputable) {
            const pct = Math.round((e.loaded / e.total) * 100);
            progressBar.style.width = pct + '%';
            progressStatus.textContent = `Uploading… ${pct}%`;
          }
        });
        xhr.addEventListener('load', () => {
          uploadEl.dataset.uploading = 'false';
          progress.hidden = true;
          if (xhr.status >= 200 && xhr.status < 300) {
            try {
              const res = JSON.parse(xhr.responseText);
              if (res.secure_url) {
                state.answers[key + 'Url'] = res.secure_url;
                state.answers[key + 'Name'] = file.name;
                previewImg.src = res.secure_url;
                filenameEl.innerHTML = '<span class="hf-wiz__upload-success">Uploaded</span> ' + escapeHTML(file.name);
                uploadEl.classList.add('has-file');
                preview.hidden = false;
                saveProgress();
                return;
              }
            } catch (err) {}
            showError('Upload succeeded but response was unexpected. Please try again.');
            empty.style.display = '';
          } else {
            showError(`Upload failed (${xhr.status}). Please try again.`);
            empty.style.display = '';
          }
        });
        xhr.addEventListener('error', () => {
          uploadEl.dataset.uploading = 'false';
          progress.hidden = true;
          empty.style.display = '';
          showError('Upload failed. Please check your connection and try again.');
        });
        xhr.send(formData);
      }
      function showError(msg) { errorEl.textContent = msg; errorEl.hidden = false; }
    });

    // ─── Prev / Next / Reset ───────────────────────────────────
    function handleNext() {
      if (validateStep(state.step)) goToStep(state.step + 1);
      else if (nextBtn) nextBtn.animate([{transform:'translateX(0)'},{transform:'translateX(-4px)'},{transform:'translateX(4px)'},{transform:'translateX(0)'}],{duration:240});
    }
    if (prevBtn) prevBtn.addEventListener('click', () => goToStep(state.step - 1));
    if (nextBtn) nextBtn.addEventListener('click', handleNext);
    if (resetBtn) resetBtn.addEventListener('click', () => {
      if (confirm('Start over? Your progress will be cleared.')) { clearProgress(); window.location.reload(); }
    });

    // ─── Pricing & review ──────────────────────────────────────
    function calcTotal() {
      let total = cfg.basePrice;
      if (state.answers.jerseySwap === 'Yes') total += cfg.jerseyPrice;
      if (state.answers.rushTurnaround === 'Yes') total += cfg.rushPrice;
      return total;
    }
    function fmt(n) { return '$' + n.toFixed(2); }
    function updateRunningTotal() {
      if (!runningTotalEl) return;
      const total = calcTotal();
      runningTotalEl.textContent = fmt(total);
      if (lastTotal !== null && total !== lastTotal && runningTotalWrap) {
        runningTotalWrap.classList.remove('is-bumped');
        void runningTotalWrap.offsetWidth;
        runningTotalWrap.classList.add('is-bumped');
      }
      lastTotal = total;
    }

    function renderReview() {
      const a = state.answers;
      const athleteRows = [
        ['Name', `${a.firstName} ${a.lastName}`.trim()],
        ['Email', a.email],
        ['Sport', a.sport],
        ['Position', a.position],
        ['Current Level', a.currentLevel]
      ];
      const statementRows = [
        ['Type', a.statementType],
        ['Current School', `${a.currentSchool}, ${a.currentSchoolCity}, ${a.currentSchoolState}`],
        ['Destination School', a.destinationSchool || '—'],
        ['Statement Text', a.statementText]
      ];
      const designRows = [
        ['Graphic Style', a.graphicStyle],
        ['Athlete Photo', a.athletePhotoName || (a.athletePhotoUrl ? 'Uploaded' : 'None')],
        ['Jersey Swap', a.jerseySwap || 'No'],
        ['Rush Delivery', a.rushTurnaround || 'No']
      ];
      const pricingRows = [['Statement Graphic', fmt(cfg.basePrice)]];
      if (a.jerseySwap === 'Yes') pricingRows.push(['Jersey Swap', '+' + fmt(cfg.jerseyPrice)]);
      if (a.rushTurnaround === 'Yes') pricingRows.push(['Rush Delivery', '+' + fmt(cfg.rushPrice)]);

      paintRows(root.querySelector('[data-hf-wiz-review="athlete"]'), athleteRows);
      paintRows(root.querySelector('[data-hf-wiz-review="statement"]'), statementRows);
      paintRows(root.querySelector('[data-hf-wiz-review="design"]'), designRows);
      paintRows(root.querySelector('[data-hf-wiz-review="pricing"]'), pricingRows);
      if (totalEl) totalEl.textContent = fmt(calcTotal());
    }
    function paintRows(container, rows) {
      if (!container) return;
      container.innerHTML = '';
      rows.forEach(([label, value]) => {
        const row = document.createElement('div');
        row.className = 'hf-wiz__review-row';
        row.innerHTML = `<dt>${escapeHTML(label)}</dt><dd>${escapeHTML(value || '—')}</dd>`;
        container.appendChild(row);
      });
    }
    function escapeHTML(s) { return String(s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;').replace(/'/g,'&#039;'); }

    // ─── Submit ────────────────────────────────────────────────
    if (submitBtn) submitBtn.addEventListener('click', submitOrder);
    async function submitOrder() {
      if (!cfg.baseVariantId) {
        showSubmitError('Base product is not configured. Please contact support.');
        return;
      }
      submitBtn.disabled = true;
      submitBtn.classList.add('is-loading');
      submitErrorEl.hidden = true;
      submitErrorEl.textContent = '';

      const a = state.answers;
      const properties = {
        'First Name': a.firstName, 'Last Name': a.lastName, 'Email': a.email,
        'Sport': a.sport, 'Position(s)': a.position,
        'Current Level': a.currentLevel,
        'Statement Type': a.statementType,
        'Current School': a.currentSchool,
        'Current School City': a.currentSchoolCity,
        'Current School State': a.currentSchoolState,
        'Destination School': a.destinationSchool || 'N/A',
        'Statement Text': a.statementText,
        'Graphic Style': a.graphicStyle,
        'Jersey Swap': a.jerseySwap || 'No',
        'Rush Delivery': a.rushTurnaround || 'No'
      };
      if (a.jerseyNumber) properties['Jersey Number'] = a.jerseyNumber;
      if (a.athletePhotoUrl) properties['Athlete Photo'] = a.athletePhotoUrl;
      if (a.athletePhotoName) properties['Athlete Photo Filename'] = a.athletePhotoName;
      if (a.signaturePhotoUrl) properties['Signature Photo'] = a.signaturePhotoUrl;
      if (a.signaturePhotoName) properties['Signature Photo Filename'] = a.signaturePhotoName;

      const items = [{ id: parseInt(cfg.baseVariantId, 10), quantity: 1, properties }];
      if (a.jerseySwap === 'Yes' && cfg.jerseyVariantId) items.push({ id: parseInt(cfg.jerseyVariantId, 10), quantity: 1 });
      if (a.rushTurnaround === 'Yes' && cfg.rushVariantId) items.push({ id: parseInt(cfg.rushVariantId, 10), quantity: 1 });

      try {
        await fetch('/cart/clear.js', { method: 'POST' });
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items })
        });
        if (!res.ok) {
          const errText = await res.text();
          let errMsg = "We couldn't add your order to cart. Please try again.";
          try {
            const errJson = JSON.parse(errText);
            if (errJson.description) errMsg = errJson.description;
            else if (errJson.message) errMsg = errJson.message;
          } catch (e) {}
          throw new Error(errMsg);
        }
        clearProgress();
        window.location.href = '/checkout';
      } catch (err) {
        submitBtn.disabled = false;
        submitBtn.classList.remove('is-loading');
        showSubmitError(err.message || 'Something went wrong. Please try again.');
      }
    }
    function showSubmitError(msg) { if (submitErrorEl) { submitErrorEl.textContent = msg; submitErrorEl.hidden = false; } }

    // ─── Init ──────────────────────────────────────────────────
    lastTotal = calcTotal();
    if (runningTotalEl) runningTotalEl.textContent = fmt(lastTotal);

    const saved = loadProgress();
    if (saved && saved.answers) {
      Object.assign(state.answers, saved.answers);
      restoreUI();
      const startStep = Math.max(1, Math.min(TOTAL_STEPS, saved.step || 1));
      goToStep(startStep);
    } else {
      goToStep(1);
    }
  }

  function bootAll() {
    document.querySelectorAll('[data-hf-wiz][data-wizard-type="statement"]').forEach(initWizard);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bootAll);
  else bootAll();
  document.addEventListener('shopify:section:load', bootAll);
})();
